import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditTeamSettings = lazy(() =>
  import("../../../../../../../app-settings").then((module) => ({
    default: module.default.EditTeamSettings,
  }))
);

export const editTeamSettingsNRO: NavigationRoutingObject = {
  Component: EditTeamSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("edit-team-settings-nro-heading", "Edit Team Settings"),
  pageNameForTracking: () => "Edit Team Settings",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("territories") && hasPermission("appGroup", { permission: "editTeams" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/territories/:appGroupId",
};
